export const filasIntegracaoFilterFields = [
  {
    name: "lojaId",
    label: "Loja",
    placeholder: "Selecione uma loja",
    type: "select" as const,
    options: [],
  },
  {
    name: "displayId",
    label: "Nº do pedido (Display)",
    placeholder: "Ex.: 123",
    type: "text" as const,
  },
  {
    name: "orderId",
    label: "Nº do pedido (Original)",
    placeholder: "Ex.: 456",
    type: "text" as const,
  },
];
